<div class="tema-movil min-h-screen bg-[var(--bg)]">
  <div class="text-white px-5 py-4 flex items-center justify-between" style="background: var(--ink)">
    <div>
      <div class="text-[15px] font-bold">Nuevo proveedor</div>
      <div class="font-mono text-[11px] text-[var(--blue-soft)]">{{ codigo() }}</div>
    </div>
    <button (click)="cancelar()" class="text-[12px] text-[#AEB9CC]">Cancelar</button>
  </div>

  <div class="p-4 space-y-4">
    @if (espacioBajo()) {
      <div class="bg-[var(--coral-soft)] text-[var(--coral-ink)] rounded-xl px-3.5 py-2.5 text-[12px] font-semibold">
        ⚠ Poco espacio libre en el dispositivo — sincroniza pronto o libera espacio antes de seguir capturando.
      </div>
    }
    @if (mensajeError()) {
      <p class="text-[12.5px] font-semibold px-3.5 py-2.5 rounded-lg text-[var(--coral-ink)] bg-[var(--coral-soft)]">
        ⚠ {{ mensajeError() }}
      </p>
    }
    <app-camara-captura etiqueta="Foto de la tarjeta de presentación (obligatoria)" (foto)="alCapturarTarjeta($event)" />

    <div class="bg-[var(--surface)] border border-[var(--border)] rounded-lg px-3.5 py-3 text-[12px] text-[var(--muted)]">
      <b class="text-[var(--ink)]">Regla de feria:</b> solo la tarjeta es obligatoria acá. Lo demás se llena en el hotel — no teclear frente al proveedor.
    </div>

    <div>
      <label for="nuevo-proveedor-nombre" class="block text-[10.5px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1.5">Nombre proveedor (opcional)</label>
      <input id="nuevo-proveedor-nombre" [ngModel]="nombre()" (ngModelChange)="nombre.set($event)" placeholder="La tarjeta ya lo tiene"
             class="w-full border border-[var(--border)] rounded-lg px-3 py-3 text-[14px] bg-[var(--surface)]" />
      @if (leyendoNombre()) {
        <p class="text-[11px] text-[var(--faint)] mt-1">🔎 Leyendo nombre de la tarjeta…</p>
      }
    </div>
    <!-- Mantenemos el layout compacto y conservamos ubicacion vacia por compatibilidad. -->
    <div class="grid grid-cols-2 gap-3">
      <div>
        <label for="nuevo-proveedor-contacto" class="block text-[10.5px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1.5">Contacto</label>
        <input id="nuevo-proveedor-contacto" [ngModel]="contacto()" (ngModelChange)="contacto.set($event)" placeholder="Opcional"
               class="w-full border border-[var(--border)] rounded-lg px-3 py-3 text-[14px] bg-[var(--surface)]" />
      </div>
      <div>
        <label for="nuevo-proveedor-telefono" class="block text-[10.5px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1.5">Teléfono/WeChat</label>
        <input id="nuevo-proveedor-telefono" [ngModel]="telefono()" (ngModelChange)="telefono.set($event)" placeholder="Opcional"
               class="w-full border border-[var(--border)] rounded-lg px-3 py-3 text-[14px] bg-[var(--surface)]" />
      </div>
    </div>

    <button (click)="guardarYCapturar()" [disabled]="guardando()"
            class="w-full text-[15px] font-bold py-4 rounded-xl text-white disabled:opacity-50"
            style="background: var(--sage)">
      {{ guardando() ? 'Guardando…' : 'Guardar y empezar a capturar ▶' }}
    </button>
  </div>
</div>
